import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Loading from '../../../components/Loading';
import * as Styles from '../Dashboard.styles';

const ListBookmark = ({
  code,
  checked,
  setChecked,
  isLoading,
  investmentCategories,
  saveInvestmentCategory,
  deleteInvestmentCategory,
}) => {
  const handleToggle = (value) => async () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      const status = await saveInvestmentCategory(value, code);
      if (status) {
        newChecked.push(value);
      }
    } else {
      newChecked.splice(currentIndex, 1);
      deleteInvestmentCategory(value, code);
    }
    setChecked(newChecked);
  };
  return (
    <div>
      <Typography
        sx={{ mt: 4, mb: 2 }}
        variant="h6"
        className="text-black text-center"
        component="div"
      >
        {`Danh Mục Theo Dõi Của ${code}`}
      </Typography>
      {isLoading ? <Styles.EmptyTag /> : null}
      <Loading isLoading={isLoading} className="white" />
      {!isLoading ? (
        investmentCategories && !!investmentCategories.length ? (
          <List dense sx={{ width: '100%', maxWidth: 360 }}>
            {investmentCategories.map((investmentCategory) => {
              const labelId = `checkbox-list-secondary-label-${investmentCategory.id}`;
              return (
                <ListItem
                  key={investmentCategory.id}
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      checked={checked.indexOf(investmentCategory.id) !== -1}
                      inputProps={{ 'aria-labelledby': labelId }}
                    />
                  }
                  disablePadding
                  onClick={handleToggle(investmentCategory.id)}
                >
                  <ListItemButton>
                    <ListItemText
                      id={labelId}
                      primary={investmentCategory.name}
                      className="text-black"
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        ) : (
          'No Data'
        )
      ) : null}
    </div>
  );
};

export default ListBookmark;
